<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>settings_accessibility</mat-icon> Grower Properties
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <p>
        Search registered Hort360 users. To locate relevant properties please enter their grower company name, ABN, address, email, username or property details.
        </p>
        <app-grower-search (selected)="userProfile($event)"></app-grower-search>
    </mat-card-content>
</mat-card>

<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>history</mat-icon> Recent Properties
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-card-content class="row pl-2 pr-2">

        <app-grower-recent (selected)="userProfile($event)"></app-grower-recent>

      </mat-card-content>
    </mat-card-content>
</mat-card>



